/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/10/2023
 */
import * as React from "react";
import "./styles/ProfileDropdown.styles.scss";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import AuthService from "../services/AuthService";
import MyProfileDetails from "./components/MyProfileDetails";
import { ReactComponent as WhiteLogo } from "../../../resources/WhiteLogoNoBackground.svg" 


const drawerWidth = 240;
const theme = createTheme({
  palette: {
    secondary: {
      // This is green.A700 as hex.
      main: "#116c6f",
    },
  
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


const Header = ({ handleDrawerOpen, open }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMyProfile = () => {
    navigate("myProfile");
  };

  const handleSettingBtn = () => {
    navigate("controlPanel");
  };

  const handleRouteDashboard = () => {
    navigate("dashboard");
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <AppBar color="secondary" position="fixed" open={open} title={"Header"}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                flexGrow: 1,
                cursor: "pointer",
                "font-family": "Montserrat",
              }}
              onClick={handleRouteDashboard}
            >
              {!open && <WhiteLogo />}
            </Typography>
            <div>
              <IconButton
                title="Control Panel"
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={handleSettingBtn}
              >
                <SettingsIcon fontSize="large" />
              </IconButton>
            </div>
            <div>
              <IconButton
                title="Profile"
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle fontSize="large" />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <Box className="wrapper">
                  <MyProfileDetails
                    handleMyProfile={handleMyProfile}
                    logout={AuthService.Logout}
                  />
                </Box>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </div>
  )
};
export default Header;
